import { h } from 'preact';
import { intcomma } from 'journalize';

function OtherCandidate({
  isViewable,
  party,
  votes,
  totalVotes,
  candidateCount,
  onClick,
}) {
  let rowClass = 'candidate contest__candidate-row';

  if (!isViewable) {
    rowClass += ' contest__candidate-row--hidden';
  }

  const partyInitial = party.slice(0, 1).toUpperCase();

  return (
    <tr class={rowClass}>
      <td class="candidate__cell candidate__party" />
      <th class="candidate__cell candidate__name">
        <button onClick={onClick}>
          {candidateCount} other{candidateCount > 1 && 's'}{' '}
          <svg class="icon icon-angle-down">
            <use xlinkHref="#icon-angle-down" />
          </svg>
        </button>
      </th>
      <td class="candidate__cell candidate__votes">{intcomma(votes)}</td>
      <td class="candidate__cell candidate__pct">
        {totalVotes <= 0 ? '-' : (votes / totalVotes * 100).toFixed(1)}
        <span class="candidate__pct-symbol">%</span>
      </td>
    </tr>
  );
}

export default OtherCandidate;



// WEBPACK FOOTER //
// ./componentsV2/OtherCandidate.js